<template>
  <div v-if="mostrarContenido" class="producto-detalle-container">
    <div class="galeria" ref="galeriaProducto" tabindex="-1">
      <!-- Miniaturas -->
      <div class="miniaturas" ref="miniaturas">
        <div
          v-for="(img, i) in imagenes"
          :key="img.key"
          @click="seleccionarImagen(i)"
          class="miniatura-item"
          :class="{ activa: imagenActualKey === img.key, agotada: img.agotada }"
        >
          <img :src="img.url" />
          <span v-if="img.agotada" class="miniatura-agotado">Agotado</span>
        </div>
        <div v-if="imagenesRestantes > 0" class="miniatura-extra">
          +{{ imagenesRestantes }}
        </div>
      </div>

      <!-- Imagen principal -->
      <div
        class="imagen-principal-wrapper"
        @click="esAdmin ? abrirSelectorImagen() : toggleZoom"
      >
        <img
          :src="imagenActualUrl"
          class="imagen-principal"
          :class="{ zoom: zoomActivo }"
          @load="programarVistaEnFotos"
        />
        <div
          v-if="esAdmin && imagenActualEsPlaceholder"
          class="sin-imagen-label"
        >
          SIN IMAGEN
        </div>
        <div v-else-if="imagenActualAgotada" class="agotado-watermark">
          AGOTADO
        </div>
        <input
          v-if="esAdmin"
          type="file"
          ref="archivoImagen"
          accept="image/*"
          style="display: none"
          @change="subirNuevaImagen"
        />
        <a
          href="#"
          class="descargar-imagen"
          @click.stop.prevent="descargarImagen"
        >
          <i class="mdi mdi-download"></i>
        </a>
      </div>
    </div>

    <!-- Información del producto -->
    <div class="info-producto">
      <div v-if="editMode" class="field">
          <label class="label is-small">Nombre</label>
          <div class="control">
            <input class="input" v-model="producto.nombre" @change="actualizarCampo('nombre', producto.nombre)">
          </div>
      </div>
      <h1 v-else class="nombre">{{ producto.nombre }}</h1>
      <div v-if="editMode" class="field">
          <label class="label is-small">Referencia/Código</label>
          <div class="control">
             <input class="input is-small" v-model="producto.codigo" @change="actualizarCampo('codigo', producto.codigo)">
          </div>
      </div>
      <p v-else class="codigo">Referencia: {{ producto.codigo }}</p>
      <div v-if="editMode" class="field">
          <label class="label is-small">Ubicación Estante</label>
          <div class="control">
             <input class="input is-small" v-model="producto.estante" placeholder="Sin estante" @change="actualizarCampo('estante', producto.estante)">
          </div>
      </div>
      <p
        v-else-if="mostrarUbicacion"
        class="ubicacion"
        title="Ubicación en bodega"
      >
        Ubicación: <strong>{{ producto.estante || 'Sin estante' }}</strong>
      </p>
      <div class="bloque-precios-descuento">
        <template v-if="precioDisponible(precioFinal)">
          <div class="detalle-precio-row">
            <span class="precio-mayorista">${{ formatoPrecio(precioFinal) }}</span>
            <span v-if="porcentajeDescuentoProducto" class="precio-anterior">
              ${{ formatoPrecio(precioOriginalFinal) }}
            </span>
          </div>
          <div v-if="porcentajeDescuentoProducto" class="descuento-producto">
            {{ porcentajeDescuentoProducto }}% de descuento
          </div>
        </template>
        <div v-else class="precio-consultar">
          Consultar precio
        </div>

        <div v-if="precioDisponible(producto.precioMayoreo)" class="precio-docena">
          <span class="label-precio">Precio por docena:</span>
          <span>${{ formatoPrecio(producto.precioMayoreo) }}</span>
        </div>
      </div>
      <div
        v-if="selectedTallaInfo && selectedTallaInfo.precioAdicional"
        class="precio-adicional"
      >
        +${{ Number(selectedTallaInfo.precioAdicional).toLocaleString() }}
        adicional
      </div>
      <p v-if="totalUnidades" class="total-unidades">
        Unidades disponibles: {{ totalUnidades }}
      </p>

      <p v-if="producto.observaciones" class="observaciones">
        {{ producto.observaciones }}
      </p>

      <div v-if="tallasParaImagen.length" class="seccion-tallas">
        <label class="label-tallas">{{ labelTallasImagen }}</label>
        <div class="tallas" :key="'tallas-' + imagenActualKey">
          <button
            v-for="(t, i) in tallasParaImagen"
            :key="producto.id + '-' + imagenActualKey + '-' + t.talla + '-' + i"
            :class="{ activa: tallaSeleccionada === t.talla, agotada: Number(t.disponible || 0) <= 0 }"
            :disabled="Number(t.disponible || 0) <= 0"
            @click="seleccionarTalla(t)"
          >
            {{ formatoEtiquetaTalla(t) }}
          </button>
        </div>
      </div>

      <div v-else class="talla-desconocida" :class="{ admin: esAdmin }">
        <span v-if="esAdmin">ESTE PRODUCTO NO TIENE TALLA RELACIONADA</span>
        <span v-else>SIN TALLA SUJETO A DISPONIBILIDAD</span>
      </div>
      <div class="input-cantidad">
        <button
          @click="cambiarCantidad(-1)"
          :disabled="cantidad <= 1 || deshabilitarCantidad"
        >
          -
        </button>
        <span>{{ cantidad }}</span>
        <button
          @click="cambiarCantidad(1)"
          :disabled="
            cantidad >= (selectedTallaInfo?.disponible ?? Infinity) ||
            deshabilitarCantidad
          "
        >
          +
        </button>
      </div>

      <div class="acciones-producto">
        <button
          class="btn-agregar-carrito"
          :disabled="deshabilitarAgregarCarrito"
          @click="preguntarObservacion"
        >
          <i class="mdi mdi-cart-plus"></i>
          Agregar al carrito
        </button>
        <button class="btn-copiar-link" @click="copiarLinkProducto">
          <i class="mdi mdi-link-variant"></i>
          Copiar link
        </button>
      </div>
      
      <!-- ADMIN INV VIEW -->
      <div v-if="esAdmin" class="admin-controls mb-4 is-flex is-align-items-center">
        <label class="switch mr-2">
          <input type="checkbox" v-model="editMode">
          <span class="slider round"></span>
        </label>
        <span class="has-text-weight-bold" :class="editMode ? 'has-text-warning-dark' : 'has-text-grey'">
          {{ editMode ? '✏️ MODO EDICIÓN ACTIVO' : 'Modo Lectura (Activa para editar)' }}
        </span>
      </div>

      <div v-if="esAdmin && producto.imagenesAdicionales" class="admin-stock-view">
        <h4 class="title is-6 mb-2">
          📦 Stock Global (Vista Admin) 
          <span v-if="editMode" class="tag is-warning is-light">Editando...</span>
        </h4>
        <div class="table-container">
          <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th>Img</th>
                <th>Talla</th>
                <th>Stock</th>
                <th>Precio Adic.</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="varGroup in producto.imagenesAdicionales">
                 <tr v-for="(talla, idx) in varGroup.tallas" :key="varGroup.imagenRelacionada + '-' + idx">
                    <td v-if="idx === 0" :rowspan="varGroup.tallas.length" style="vertical-align: middle; text-align: center;">
                       <img :src="obtenerUrlImagenKey(varGroup.imagenRelacionada)" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;">
                    </td>
                    <td>{{ talla.talla }}</td>
                    <td :class="{'has-text-danger': talla.existencia <= 0, 'has-text-success': talla.existencia > 0}">
                      <input v-if="editMode" 
                             class="input is-small" 
                             type="number" 
                             v-model.number="talla.existencia" 
                             style="width: 70px"
                             @change="actualizarStock(talla, varGroup.imagenRelacionada)">
                      <b v-else>{{ talla.existencia }}</b>
                    </td>
                    <td>{{ talla.precioAdicional ? '+ $' + Number(talla.precioAdicional).toLocaleString() : '-' }}</td>
                 </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <hr>

      <!-- RATINGS SECTION -->
      <div class="mt-6 pt-5" style="border-top: 1px solid #eee;">
        <h3 class="title is-4 has-text-centered has-text-weight-light mb-5" style="letter-spacing: 1px;">OPINIONES DE CLIENTES</h3>
        
        <!-- List -->
        <div v-if="calificaciones.length > 0" class="mb-5 reviews-list">
            <div v-for="(cal, index) in calificaciones" :key="index" class="media review-item box mb-3 is-shadowless" style="border: 1px solid #f5f5f5;">
                <figure class="media-left">
                    <p class="image is-48x48">
                        <img src="https://ui-avatars.com/api/?background=random&color=fff" class="is-rounded" alt="Avatar">
                    </p>
                </figure>
                <div class="media-content">
                    <div class="content">
                        <p>
                            <strong>{{ cal.nombre_usuario }}</strong> <small class="has-text-grey-light ml-2">{{ cal.fecha || 'Reciente' }}</small>
                            <br>
                            <span class="has-text-warning">
                                <i class="mdi mdi-star" v-for="n in parseInt(cal.estrellas)" :key="n"></i>
                            </span>
                            <br>
                            {{ cal.comentario }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="has-text-centered mb-5">
            <p class="has-text-grey-light is-italic">Nadie ha calificado este producto aún. ¡Sé el primero!</p>
        </div>

        <!-- Form -->
        <div class="box is-shadowless" style="background: #fafafa; border-radius: 12px;">
            <p class="subtitle is-6 has-text-weight-bold mb-4">Escribe una reseña</p>
            
            <div class="field">
                <label class="label is-small">Tu Calificación</label>
                <div class="control">
                     <div class="select is-rounded is-fullwidth">
                        <select v-model="nuevoComentario.estrellas">
                            <option value="5">★★★★★ Excellent</option>
                            <option value="4">★★★★ Muy bueno</option>
                            <option value="3">★★★ Regular</option>
                            <option value="2">★★ Malo</option>
                            <option value="1">★ Terrible</option>
                        </select>
                    </div>
                </div>
            </div>
            
            <div class="field">
                 <div class="control has-icons-left">
                     <input class="input is-rounded" type="text" placeholder="Tu nombre" v-model="nuevoComentario.nombre">
                     <span class="icon is-small is-left">
                        <i class="mdi mdi-account"></i>
                     </span>
                 </div>
            </div>
            
            <div class="field">
                 <div class="control">
                     <textarea class="textarea is-rounded" placeholder="Cuéntanos qué te pareció..." v-model="nuevoComentario.comentario" rows="3"></textarea>
                 </div>
            </div>
            
            <div class="has-text-right">
                <button class="button is-black is-rounded px-5" @click="enviarCalificacion">
                    <span>Enviar Opinión</span>
                    <span class="icon is-small ml-2">
                        <i class="mdi mdi-send"></i>
                    </span>
                </button>
            </div>
        </div>
      </div>

      <!-- HAPPY CLIENTS SECTION -->
      <div class="box mt-5" v-if="clientesFelices.length > 0">
        <h3 class="title is-5">Clientes Felices</h3>
        <div class="columns is-multiline">
            <div class="column is-4" v-for="cliente in clientesFelices" :key="cliente.id">
                <div class="card testimonial-card">
                    <div class="card-content has-text-centered">
                        <figure class="image is-64x64 is-inline-block">
                            <img :src="obtenerUrl(cliente.foto)" class="is-rounded" style="height:64px; width:64px; object-fit:cover;">
                        </figure>
                        <p class="title is-6 mt-2">{{ cliente.nombre }}</p>
                        <p class="subtitle is-6 is-italic">"{{ cliente.descripcion }}"</p>
                    </div>
                </div>
            </div>
        </div>
      </div>

    </div>
    <!-- ...dentro de <div class="info-producto"> -->
  </div>
</template>

<script>
import HttpService from "@/Servicios/HttpService";
import Swal from "sweetalert2";
import MetricaService from "@/Servicios/MetricaService";

export default {
  data() {
    return {
      producto: {},
      imagenes: [],
      imagenActualKey: "",
      tallaSeleccionada: null,
      zoomActivo: false,
      cantidad: 1, // NUEVO: cantidad seleccionada
      precioAdicionalSeleccionado: 0,
      rol: localStorage.getItem("rol") || "", // 💡 Setealo acá
      mostrarContenido: true,
      imagenesRestantes: 0,
      calificaciones: [],
      clientesFelices: [],
      nuevoComentario: { nombre: "", comentario: "", estrellas: 5 },
      editMode: false, // NUEVO
    };
  },
  computed: {
    esAdmin() {
      return this.rol === "administrador";
    },
    esMayorista() {
      console.log("rol", localStorage.getItem("rol")); // ✅
      const rol = localStorage.getItem("rol");
      return (
        rol === "mayorista" ||
        rol === "administrador" ||
        rol === "cajero" ||
        rol === "inven"
      );
    },
    mostrarUbicacion() {
      return !!this.rol;
    },
    imagenActualUrl() {
      const img = this.imagenes.find((i) => i.key === this.imagenActualKey);
      return img?.url || "";
    },
    imagenActualEsPlaceholder() {
      const img = this.imagenes.find((i) => i.key === this.imagenActualKey);
      return !!img?.placeholder;
    },
    imagenActualAgotada() {
      const img = this.imagenes.find((i) => i.key === this.imagenActualKey);
      return !!img?.agotada;
    },
    currentAdicional() {
      return (
        this.producto.imagenesAdicionales?.find(
          (a) => a.imagenRelacionada === this.imagenActualKey
        ) || null
      );
    },
    tallasParaImagen() {
      const ad = this.currentAdicional;
      let base = [];
      if (ad && Array.isArray(ad.tallas)) {
        base = ad.tallas;
      } else if (Array.isArray(this.producto.tallasSeleccionadas)) {
        base = this.producto.tallasSeleccionadas.map((t) => ({
          talla: t,
          existencia: 0,
          precioAdicional: 0,
        }));
      }

      // Calcula disponibilidad restando lo agregado al carrito
      return base.map((t) => {
        const enCarrito = this.$store.state.carrito
          .filter(
            (p) =>
              p.id === this.producto.id &&
              p.imagenKey === this.imagenActualKey &&
              p.talla === t.talla
          )
          .reduce((acc, prod) => acc + prod.cantidad, 0);
        return {
          ...t,
          disponible: Number(t.existencia || 0) - enCarrito,
        };
      });
    },
    selectedTallaInfo() {
      if (!this.tallaSeleccionada) return null;
      return (
        this.tallasParaImagen.find(
          (ti) =>
            (typeof ti === "object" ? ti.talla : ti) === this.tallaSeleccionada
        ) || null
      );
    },
    precioBase() {
      const enCarrito = this.$store.state.carrito
        .filter((p) => p.id === this.producto.id)
        .reduce((acc, prod) => acc + prod.cantidad, 0);
      const total = enCarrito + this.cantidad;
      if (this.producto.precioMayoreo && total >= 12) {
        return Number(this.producto.precioMayoreo);
      }
      return Number(this.producto.precioVenta || this.producto.precioVenta2 || 0);
    },
    precioFinal() {
      const adicional = this.selectedTallaInfo?.precioAdicional
        ? Number(this.selectedTallaInfo.precioAdicional)
        : 0;
      return this.precioBase + adicional;
    },
    precioOriginalFinal() {
      const adicional = this.selectedTallaInfo?.precioAdicional
        ? Number(this.selectedTallaInfo.precioAdicional)
        : 0;
      return Number(this.producto.precioVenta2 || 0) + adicional;
    },
    porcentajeDescuentoProducto() {
      const oferta = Number(this.precioFinal || 0);
      const original = Number(this.precioOriginalFinal || 0);
      if (!oferta || !original || original <= oferta) return 0;
      return Math.round(((original - oferta) / original) * 100);
    },
    totalUnidades() {
      if (!Array.isArray(this.producto.imagenesAdicionales)) return 0;
      return this.producto.imagenesAdicionales.reduce((acc, img) => {
        if (Array.isArray(img.tallas)) {
          return (
            acc +
            img.tallas.reduce((s, t) => {
              const enCarrito = this.$store.state.carrito
                .filter(
                  (p) =>
                    p.id === this.producto.id &&
                    p.imagenKey === img.imagenRelacionada &&
                    p.talla === t.talla
                )
                .reduce((a, prod) => a + prod.cantidad, 0);
              return s + Number(t.existencia || 0) - enCarrito;
            }, 0)
          );
        }
        return acc;
      }, 0);
    },
    hayStockImagenActual() {
      return this.tallasParaImagen.some((t) => Number(t.disponible || 0) > 0);
    },
    labelTallasImagen() {
      return this.hayStockImagenActual ? "Tallas disponibles:" : "Tallas agotadas:";
    },
    deshabilitarCantidad() {
      return this.tallasParaImagen.length > 0 && !this.tallaSeleccionada;
    },
    deshabilitarAgregarCarrito() {
      return (
        this.imagenActualAgotada ||
        this.deshabilitarCantidad ||
        (this.selectedTallaInfo && Number(this.selectedTallaInfo.disponible || 0) <= 0)
      );
    },
  },
  watch: {
    imagenes() {
      this.$nextTick(() => {
        // Limpia listeners anteriores
        if (this._miniaturasImgs) {
          this._miniaturasImgs.forEach((img) =>
            img.removeEventListener("load", this.actualizarImagenesRestantes)
          );
        }
        // Vuelve a poner listeners a los nuevos imgs
        if (this.$refs.miniaturas) {
          this._miniaturasImgs = Array.from(
            this.$refs.miniaturas.querySelectorAll("img")
          );
          this._miniaturasImgs.forEach((img) =>
            img.addEventListener("load", this.actualizarImagenesRestantes)
          );
        }
        this.actualizarImagenesRestantes();
      });
    },
    producto(val) {
      if (val && val.id) {
        this.cargarCalificaciones();
      }
    },
  },
  async mounted() {
    this.programarVistaEnFotos();
    this.actualizarRol();
    window.addEventListener("storage", this.actualizarRol);
    this.cargarClientesFelices();
    const id = this.$route.params.id;
    this.$forceUpdate(); // 🔥 actualiza todo el componente manualmente
    this.$nextTick(() => {
      // ...tu código de agregar listeners a scroll, resize...
      // Ahora agrega listeners al load de cada imagen
      if (this.$refs.miniaturas) {
        const imgs = this.$refs.miniaturas.querySelectorAll("img");
        imgs.forEach((img) => {
          img.addEventListener("load", this.actualizarImagenesRestantes);
        });
      }
    });

    const res = await HttpService.obtenerConConsultas("productos.php", {
      accion: "obtenerProductoPorId",
      id,
    });
    if (!res || !res.id) {
      this.mostrarContenido = false;
      return;
    }
    this.producto = res;
    this.imagenes = this.obtenerImagenes(res);
    const visitaId = sessionStorage.getItem("visitaId");
    if (visitaId) {
      const imgs = this.imagenes.map((i) => i.url).join(",");
      MetricaService.registrarVistaProducto({
        visita_id: visitaId,
        producto_id: this.producto.id,
        imagenes: imgs,
      });
    }
    this.imagenActualKey = this.imagenes[0]?.key || "";
    this.mostrarInfoTallas();
    this.$nextTick(() => {
      this.programarVistaEnFotos();
      this.actualizarImagenesRestantes();
      if (this.$refs.miniaturas) {
        this.$refs.miniaturas.addEventListener(
          "scroll",
          this.actualizarImagenesRestantes
        );
      }
      window.addEventListener("resize", this.actualizarImagenesRestantes);
    });
  },
  beforeDestroy() {
    if (this._rafVistaFotos) {
      cancelAnimationFrame(this._rafVistaFotos);
      this._rafVistaFotos = null;
    }
    window.removeEventListener("storage", this.actualizarRol);
    if (this.$refs.miniaturas) {
      this.$refs.miniaturas.removeEventListener(
        "scroll",
        this.actualizarImagenesRestantes
      );
    }
    window.removeEventListener("resize", this.actualizarImagenesRestantes);
    if (this.$refs.miniaturas) {
      const imgs = this.$refs.miniaturas.querySelectorAll("img");
      imgs.forEach((img) => {
        img.removeEventListener("load", this.actualizarImagenesRestantes);
      });
    }
  },
  methods: {
    programarVistaEnFotos() {
      this._forzarVistaFotosHasta = Date.now() + 1800;
      this.$nextTick(() => {
        this.mantenerVistaEnFotos();
        setTimeout(() => this.mantenerVistaEnFotos(), 120);
        setTimeout(() => this.mantenerVistaEnFotos(), 420);
        setTimeout(() => this.mantenerVistaEnFotos(), 900);
      });
    },
    mantenerVistaEnFotos() {
      this.llevarVistaAFotos();
      if (Date.now() > (this._forzarVistaFotosHasta || 0)) return;
      if (this._rafVistaFotos) cancelAnimationFrame(this._rafVistaFotos);
      this._rafVistaFotos = requestAnimationFrame(() => this.mantenerVistaEnFotos());
    },
    llevarVistaAFotos() {
      const galeria = this.$refs.galeriaProducto;
      const activo = document.activeElement;
      if (
        activo &&
        ["INPUT", "TEXTAREA", "SELECT", "BUTTON"].includes(activo.tagName) &&
        typeof activo.blur === "function"
      ) {
        activo.blur();
      }
      if (galeria && typeof galeria.scrollIntoView === "function") {
        if (typeof galeria.focus === "function") {
          galeria.focus({ preventScroll: true });
        }
        galeria.scrollIntoView({ block: "start", inline: "nearest", behavior: "auto" });
        return;
      }
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    actualizarRol() {
      this.rol = localStorage.getItem("rol") || "";
    },
    precioDisponible(precio) {
      return Number(precio || 0) > 0;
    },
    formatoPrecio(precio) {
      return Number(precio || 0).toLocaleString("es-CO");
    },
    slugify(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "") || "producto";
    },
    urlProducto() {
      const ruta = this.$router.resolve({
        name: "ProductoDetalle",
        params: {
          id: this.producto.id || this.$route.params.id,
          slug: this.slugify(this.producto.nombre || this.producto.codigo)
        }
      });
      return `${window.location.origin}${window.location.pathname}${ruta.href}`;
    },
    async copiarTexto(texto) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(texto);
        return;
      }
      const input = document.createElement("textarea");
      input.value = texto;
      input.style.position = "fixed";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      input.remove();
    },
    async copiarLinkProducto() {
      await this.copiarTexto(this.urlProducto());
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1200,
        icon: "success",
        title: "Link copiado",
      });
    },
    actualizarImagenesRestantes() {
      const cont = this.$refs.miniaturas;
      if (!cont) {
        this.imagenesRestantes = 0;
        return;
      }
      const item = cont.querySelector("img") || cont.firstElementChild;
      if (!item) {
        this.imagenesRestantes = 0;
        return;
      }
      const gap = parseFloat(getComputedStyle(cont).gap || 0);
      const itemHeight = item.offsetHeight;
      const oculto = cont.scrollHeight - (cont.scrollTop + cont.clientHeight);
      const faltan = Math.ceil(oculto / (itemHeight + gap));
      this.imagenesRestantes = Math.max(0, faltan);
    },
    cambiarCantidad(delta) {
      const max = this.selectedTallaInfo?.disponible ?? Infinity;
      const nueva = this.cantidad + delta;
      if (nueva >= 1 && nueva <= max) {
        this.cantidad = nueva;
      }
    },
    async preguntarObservacion() {
      if (!this.precioDisponible(this.precioFinal)) {
        await Swal.fire({
          icon: "info",
          text: "Este producto tiene precio por confirmar. EscrÃ­benos para validarlo antes de agregarlo al carrito.",
          confirmButtonColor: "#2c73d2",
        });
        return;
      }
      if (this.tallasParaImagen.length > 0 && !this.tallaSeleccionada) {
        await Swal.fire({
          icon: "info",
          text: "Debe seleccionar una talla primero",
          confirmButtonColor: "#2c73d2",
        });
        return;
      }
      const { isConfirmed, isDismissed } = await Swal.fire({
        title: "¿Deseas agregar una observación a este producto?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, agregar observación",
        cancelButtonText: "Agregar al carrito",
        confirmButtonColor: "#2c73d2",
        cancelButtonColor: "#1b365d",
        background: "#fff",
        customClass: {
          popup: "swal2-popup-custom",
        },
      });

      if (isConfirmed) {
        // Elige "Sí, agregar observación"
        const { value: observacion, isConfirmed: confirmarObs } =
          await Swal.fire({
            title: "Escribe tu observación (opcional)",
            input: "text",
            inputPlaceholder: "Color, empaque, detalles…",
            confirmButtonText: "Agregar al carrito",
            confirmButtonColor: "#2c73d2",
            background: "#fff",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            cancelButtonColor: "#1b365d",
          });

        if (confirmarObs) {
          this.agregarAlCarrito(observacion);
        }
        // Si cancela aquí, no se agrega nada
      } else if (isDismissed) {
        // Elige "Agregar al carrito" en el primer paso
        console.log("No se agregó observación, va directo al carrito");
        this.agregarAlCarrito("");
      }
    },

    agregarAlCarrito(observacion) {
      let precio = this.precioFinal;

      const disponible = this.selectedTallaInfo?.disponible ?? Infinity;
      if (this.cantidad > disponible) {
        Swal.fire({
          icon: "error",
          text: `Solo quedan ${disponible} unidades disponibles`,
          confirmButtonColor: "#2c73d2",
        });
        return;
      }

      const item = {
        // La clave es: producto, imagen, talla y tipo
        id: this.producto.id,
        nombre: this.producto.nombre,
        codigo: this.producto.codigo,
        talla: this.tallaSeleccionada || "Sin talla",
        tipo: this.producto.tipo || "N/A",
        cantidad: this.cantidad, // aquí va la cantidad seleccionada
        precio,
        precioAdicional: this.selectedTallaInfo?.precioAdicional || 0,
        imagen: this.imagenActualUrl,
        imagenKey: this.imagenActualKey, // clave de referencia
        observacion: observacion || "",
      };

      this.$store.commit("agregarAlCarrito", item);
      // SOLO si es mayorista
      if (this.esMayorista) {
        this.$store.commit("recalcularPreciosMayoreo", {
          id: this.producto.id,
          esMayorista: this.esMayorista,
          precioMayoreo: this.producto.precioMayoreo,
          precioVenta: this.producto.precioVenta,
        });
      }

      this.$store.commit("toggleCarrito", true);

      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1400,
        icon: "success",
        title: "Producto agregado al carrito",
        background: "#fff",
        customClass: { popup: "swal2-popup-custom" },
      });

      // Permitir agregar otra talla: reinicia selección y cantidad
      this.tallaSeleccionada = null;
      this.cantidad = 1;
    },
    placeholderProductoUrl() {
      return "img/sin-fotos-maxica.svg";
    },
    esImagenPlaceholder(url) {
      const limpia = String(url || "").trim().toLowerCase();
      return (
        !limpia ||
        limpia.includes("sinimagen") ||
        limpia.includes("sin-foto") ||
        limpia.includes("sinfoto") ||
        limpia.includes("placeholder") ||
        limpia.includes("megapos")
      );
    },
    normalizarUrlImagen(url) {
      if (this.esImagenPlaceholder(url)) return this.placeholderProductoUrl();
      const ruta = String(url);
      return ruta.includes("http")
        ? ruta
        : ruta.replace("../api/", "https://maxica.com.co/ximena/api/");
    },
    obtenerImagenes(producto) {
      if (!producto) return [];
      const claves = [
        "imagen1",
        "imagen2",
        "imagen3",
        "imagen4",
        "imagen5",
        "imagen6",
        "imagen7",
        "imagen8",
        "imagen9",
        "imagen10",
      ];

      if (
        producto.imagen &&
        !this.esImagenPlaceholder(producto.imagen) &&
        this.esImagenPlaceholder(producto.imagen1)
      ) {
        producto = { ...producto, imagen1: producto.imagen };
      }

      const imgs = claves
        .map((key) => {
          const url = producto[key];
          const agotada = !this.imagenTieneStock(producto, key);
          if (this.esImagenPlaceholder(url)) {
            return {
              key,
              url: this.placeholderProductoUrl(),
              placeholder: true,
              agotada: false,
            };
          }
          return {
            key,
            url: this.normalizarUrlImagen(url),
            placeholder: false,
            agotada,
          };
        })
        .filter(Boolean);
      if (this.esAdmin) return imgs;
      const reales = imgs.filter((img) => !img.placeholder);
      const conStock = reales.filter((img) => !img.agotada);
      return conStock.length ? conStock.concat(reales.filter((img) => img.agotada)) : (reales.length ? reales : [imgs[0]]);
    },
    imagenTieneStock(producto, key) {
      const grupos = Array.isArray(producto?.imagenesAdicionales)
        ? producto.imagenesAdicionales
        : [];
      const grupo = grupos.find((item) => item.imagenRelacionada === key);
      if (!grupo || !Array.isArray(grupo.tallas) || grupo.tallas.length === 0) {
        return true;
      }
      return grupo.tallas.some((t) => Number(t.existencia || 0) > 0);
    },
    formatoEtiquetaTalla(info) {
      const talla = typeof info === "object" ? info.talla : info;
      const existencia =
        typeof info === "object" && info.disponible !== undefined
          ? Number(info.disponible)
          : undefined;
      if (existencia !== undefined) {
        if (existencia <= 0) {
          return `${talla} - Agotado`;
        }
        if (existencia <= 5) {
          return `${talla} (Solo ${existencia} disponibles)`;
        }
        return `${talla} (Disp ${existencia})`;
      }
      return talla;
    },
    mostrarInfoTallas() {
      if (!sessionStorage.getItem("vistoTallasInfo")) {
        Swal.fire({
          icon: "info",
          title: "\uD83D\uDCCC Información:",
          text: "Cada imagen puede tener diferentes tallas disponibles. Revisa debajo de cada foto para ver las tallas específicas.",
          confirmButtonText: "Entendido",
          customClass: { popup: "swal2-popup-custom" },
        }).then(() => {
          sessionStorage.setItem("vistoTallasInfo", "1");
        });
      }
    },
    seleccionarTalla(info) {
      if (typeof info === "object" && Number(info.disponible || 0) <= 0) {
        return;
      }
      if (typeof info === "object") {
        this.tallaSeleccionada = info.talla;
        this.precioAdicionalSeleccionado = Number(info.precioAdicional || 0);
      } else {
        this.tallaSeleccionada = info;
        this.precioAdicionalSeleccionado = 0;
      }
    },
    seleccionarImagen(index) {
      this.imagenActualKey = this.imagenes[index].key;
      this.tallaSeleccionada = null;
      this.precioAdicionalSeleccionado = 0;
      this.zoomActivo = false;
      this.cantidad = 1; // Reinicia cantidad al cambiar imagen
    },
    toggleZoom() {
      this.zoomActivo = !this.zoomActivo;
    },
    descargarImagen() {
      const url = this.imagenActualUrl;
      const nombreBase =
        url
          .split("/")
          .pop()
          .split("?")[0]
          .replace(/\.(webp|jpe?g|png)$/i, "") || "imagen";
      fetch(url, { mode: "cors" })
        .then((r) => r.blob())
        .then(
          (blob) =>
            new Promise((resolve, reject) => {
              const img = new Image();
              img.crossOrigin = "anonymous";
              img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                canvas.toBlob(
                  (pngBlob) => {
                    if (pngBlob) resolve(pngBlob);
                    else reject(new Error("No se pudo convertir a PNG"));
                  },
                  "image/png",
                  1
                );
              };
              img.onerror = reject;
              img.src = URL.createObjectURL(blob);
            })
        )
        .then((pngBlob) => {
          const enlace = document.createElement("a");
          enlace.href = URL.createObjectURL(pngBlob);
          enlace.download = nombreBase + ".png";
          document.body.appendChild(enlace);
          enlace.click();
          enlace.remove();
          URL.revokeObjectURL(enlace.href);
        })
        .catch((err) => console.error("Error descargando imagen", err));
    },
    abrirSelectorImagen() {
      if (this.$refs.archivoImagen) {
        this.$refs.archivoImagen.click();
      }
    },
    async subirNuevaImagen(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (file.size > 10 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          text: "La imagen no debe superar 10 MB de tamaño.",
          confirmButtonColor: "#2c73d2",
        });
        e.target.value = "";
        return;
      }
      const formData = new FormData();
      formData.append("image", file);
      try {
        const resp = await HttpService.subirArchivo(
          "subir_imagen.php",
          formData
        );
        if (resp.success) {
          const path = resp.path;
          await HttpService.registrar("productos.php", {
            accion: "actualizarImagen",
            id: this.producto.id,
            columna: this.imagenActualKey,
            path,
          });
          const url = path.includes("http")
            ? path
            : path.replace("../api/", "https://maxica.com.co/ximena/api/");
          const idx = this.imagenes.findIndex(
            (i) => i.key === this.imagenActualKey
          );
          if (idx !== -1) {
            this.imagenes[idx].url = url;
          }
          this.zoomActivo = false;
          Swal.fire({
            icon: "success",
            text: "Imagen actualizada correctamente",
            confirmButtonColor: "#2c73d2",
          });
        } else {
          Swal.fire({
            icon: "error",
            text: resp.message || "Error al subir la imagen",
            confirmButtonColor: "#2c73d2",
          });
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          text: "No se pudo conectar con el servidor.",
          confirmButtonColor: "#2c73d2",
        });
      } finally {
        e.target.value = "";
      }
    },
    // --- RATINGS & CLIENTS ---
    async cargarCalificaciones() {
        this.calificaciones = await HttpService.obtenerConConsultas("funciones.php", { 
            accion: "obtenerCalificaciones", 
            idProducto: this.producto.id 
        }) || [];
    },
    async cargarClientesFelices() {
        this.clientesFelices = await HttpService.registrar("funciones.php", { accion: "obtenerClientesFelices" }) || [];
        // Optional: filter or pick random? currently showing all or carousel
    },
    async enviarCalificacion() {
        if(!this.nuevoComentario.nombre || !this.nuevoComentario.comentario) {
            Swal.fire("Error", "Completa todos los campos", "warning");
            return;
        }
        await HttpService.registrar("funciones.php", {
            accion: "registrarCalificacion",
            datos: {
                producto_id: this.producto.id,
                nombre_usuario: this.nuevoComentario.nombre,
                estrellas: this.nuevoComentario.estrellas,
                comentario: this.nuevoComentario.comentario
            }
        });
        Swal.fire("Gracias", "Tu calificación ha sido enviada", "success");
        this.nuevoComentario = { nombre: "", comentario: "", estrellas: 5 };
        this.cargarCalificaciones();
    },
    obtenerUrl(path) {
        if (this.esImagenPlaceholder(path)) return this.placeholderProductoUrl();
        if (path.startsWith('http')) return path;
        return "https://maxica.com.co/ximena/" + path;
    },
    obtenerUrlImagenKey(key) {
        const img = this.imagenes.find(i => i.key === key);
        return img ? img.url : this.placeholderProductoUrl();
    },
    async actualizarCampo(campo, valor) {
        try {
            const res = await HttpService.registrar("productos.php", {
                accion: "actualizarProductoCampo",
                id: this.producto.id,
                campo,
                valor
            });
            if (res) {
                 const toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true
                });
                toast.fire({ icon: 'success', title: 'Actualizado' });
            }
        } catch (e) {
            console.error(e);
            Swal.fire("Error", "No se pudo actualizar el campo", "error");
        }
    },
    async actualizarStock(tallaObj, imagenKey) {
        try {
            const res = await HttpService.registrar("productos.php", {
                accion: "actualizarStock",
                id: this.producto.id,
                imagenRelacionada: imagenKey,
                talla: tallaObj.talla,
                existencia: tallaObj.existencia
            });
            if (res) {
                 const toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1000
                });
                toast.fire({ icon: 'success', title: 'Stock actualizado' });
            }
        } catch (e) {
            console.error(e);
            Swal.fire("Error", "No se pudo actualizar el stock", "error");
        }
    }
  },
};
</script>


<style scoped>
.input-cantidad {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 15px;
  gap: 20px;
}
.input-cantidad button {
  background: none;
  border: none;
  font-size: 1.8rem;
  font-weight: 700;
  color: #222e;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  transition: background 0.15s;
  cursor: pointer;
  border: 1.5px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.input-cantidad button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.input-cantidad span {
  font-size: 1.4rem;
  min-width: 22px;
  text-align: center;
  color: #222;
}

.swal2-popup-custom {
  font-family: "Poppins", Arial, sans-serif;
  border-radius: 1.1em;
  box-shadow: 0 6px 28px 0 rgba(44, 115, 210, 0.08);
}

.acciones-producto {
  margin-top: 26px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
}
.btn-agregar-carrito,
.btn-copiar-link {
  background: #2c73d2;
  color: #fff;
  font-weight: 600;
  font-family: "Poppins", Arial, sans-serif;
  border: none;
  border-radius: 7px;
  padding: 12px 32px;
  font-size: 1.12rem;
  display: flex;
  align-items: center;
  gap: 9px;
  box-shadow: 0 2px 8px 0 rgba(44, 115, 210, 0.08);
  cursor: pointer;
  transition: background 0.15s;
}
.btn-copiar-link {
  background: #fff;
  color: #1b365d;
  border: 1px solid #d8e3ef;
  box-shadow: none;
}
.btn-agregar-carrito:disabled {
  background: #a0aec0;
  cursor: not-allowed;
}
.btn-agregar-carrito:hover:not(:disabled) {
  background: #1b365d;
}
.btn-copiar-link:hover {
  background: #eef5ff;
}

.producto-detalle-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 2rem;
  margin-top: 0;
}

@media (max-width: 768px) {
  .producto-detalle-container {
    flex-direction: column;
  }
}
.galeria {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 300px;
  scroll-margin-top: 92px;
  /* Lo demás igual */
}
.galeria:focus {
  outline: none;
}

.miniaturas {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: rgba(255, 255, 255, 0.88);
  padding: 8px 4px;
  border-radius: 1.2rem;
  box-shadow: 0 4px 14px 0 rgba(44, 115, 210, 0.08);
  max-height: 90%;
  overflow-y: auto;
}
.miniatura-item,
.miniatura-extra {
  width: 54px;
  height: 54px;
  border: 2px solid transparent;
  border-radius: 0.7rem;
  cursor: pointer;
  transition: border 0.18s, box-shadow 0.18s;
  background: #fff;
  box-shadow: 0 2px 4px #0001;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.miniatura-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.miniatura-item.activa {
  border-color: #2c73d2;
  box-shadow: 0 0 4px #2c73d277;
}
.miniatura-item.agotada img {
  filter: grayscale(0.55);
  opacity: 0.62;
}
.miniatura-agotado {
  position: absolute;
  left: -8px;
  right: -8px;
  top: 19px;
  transform: rotate(-14deg);
  background: rgba(185, 28, 28, 0.92);
  color: #fff;
  font-size: 8px;
  line-height: 1;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-align: center;
  text-transform: uppercase;
  padding: 3px 0;
}
.miniatura-extra {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #2c73d2;
  background: #f1f5fa;
  font-weight: bold;
  border: 2px dashed #c6d6ef;
  position: sticky;
  bottom: 0;
  z-index: 3;
}
@media (max-width: 768px) {
  .miniaturas {
    padding: 4px 2px;
    left: 4px;
  }
  .miniatura-item,
  .miniatura-extra {
    width: 38px;
    height: 38px;
  }
  .miniatura-agotado {
    top: 13px;
    font-size: 6px;
  }
}

.imagen-principal-wrapper {
  width: 100%;
  max-width: 500px;
  aspect-ratio: 1 / 1; /* Mantiene proporción cuadrada */
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  position: relative;
}

.imagen-principal {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
  cursor: zoom-in;
}

.imagen-principal.zoom {
  transform: scale(1.6);
  cursor: zoom-out;
}

.descargar-imagen {
  position: absolute;
  bottom: 2px;
  left: 89%;
  color: #191b1d;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  padding: 7px;
  font-size: 1.5rem;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.descargar-imagen:hover {
  opacity: 1;
}
.sin-imagen-label {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-weight: bold;
  font-size: 1.1rem;
}
.agotado-watermark {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 3;
  transform: translate(-50%, -50%) rotate(-12deg);
  border: 6px solid rgba(190, 18, 60, 0.92);
  color: rgba(190, 18, 60, 0.94);
  background: rgba(255, 255, 255, 0.52);
  padding: 10px 24px;
  font-size: clamp(28px, 5vw, 58px);
  line-height: 1;
  font-weight: 900;
  letter-spacing: 3px;
  text-transform: uppercase;
  pointer-events: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.7) inset;
}

/* Info producto */
.info-producto {
  flex: 1;
  min-width: 300px;
}
.nombre {
  font-size: 2rem;
  font-weight: 600;
}
.codigo {
  font-size: 1rem;
  color: #666;
  margin: 0.5rem 0;
}
.ubicacion {
  font-size: 1rem;
  color: #0f172a;
  margin: 0 0 0.5rem;
}
.ubicacion strong {
  color: #1f2937;
}
.precio {
  font-size: 1.5rem;
  color: #2c73d2;
  font-weight: bold;
  margin-bottom: 1rem;
}
.observaciones {
  font-style: italic;
  color: #555;
  margin-bottom: 1rem;
}

/* Tallas */
.label-tallas {
  font-weight: bold;
  margin-bottom: 0.5rem;
}
.tallas {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.tallas button {
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  border-radius: 0.25rem;
  transition: background 0.2s;
}
.tallas .activa {
  background: #2c73d2;
  color: white;
  border-color: #2c73d2;
}
.tallas button.agotada,
.tallas button:disabled {
  background: #f4f4f5;
  color: #991b1b;
  border-color: #fecaca;
  cursor: not-allowed;
  text-decoration: none;
  font-weight: 700;
}
.talla-desconocida {
  font-style: italic;
  color: #999;
}
.talla-desconocida.admin {
  font-size: 1.4rem;
  font-weight: bold;
  color: #d9534f;
}

.bloque-precios-mayorista,
.bloque-precios-descuento {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: black;
  background: #fafafa;
  padding: 12px 14px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #eeeeee;
  margin-bottom: 0.65rem;
}

.detalle-precio-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 9px;
}

.precio-mayorista {
  font-size: 20px;
  font-weight: bold;
  color: black;
}

.precio-anterior {
  font-size: 14px;
  color: #858585;
  text-decoration: line-through;
}

.descuento-producto {
  font-size: 13px;
  line-height: 1.2;
  font-weight: 700;
  color: #15803d;
}

.precio-docena {
  font-size: 14px;
  color: #2c73d2;
  font-weight: 600;
  margin-top: 2px;
}

.label-precio {
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
  margin-right: 4px;
}

.precio-detalle {
  font-size: 12px;
  color: #ccc;
}

.precio-normal {
  font-size: 20px;
  font-weight: bold;
  color: black;
}

.precio-consultar {
  font-size: 18px;
  font-weight: 700;
  color: #8a5b00;
}

.no-disponible {
  font-style: italic;
  color: #999;
}
.precio-adicional {
  font-size: 13px;
  color: #555;
  margin-bottom: 0.5rem;
}
.total-unidades {
  font-size: 13px;
  color: #222;
  margin-bottom: 1rem;
}
@media (min-width: 1025px) {
  .producto-detalle-container {
    display: grid;
    grid-template-columns: 60% 40%; /* 60% Galería, 40% Info */
    gap: 40px;
    align-items: start;
    max-width: 1400px;
    margin: 0 auto;
    padding: 2rem 4rem;
  }

  .galeria {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding-left: 80px; /* Espacio para miniaturas */
    position: relative;
    /* Ajustar altura máxima para que no sea inmensa */
    max-height: 800px; 
  }

  .miniaturas {
    position: absolute;
    left: 0;
    top: 0;
    transform: none;
    z-index: 2;
    flex-direction: column;
    margin: 0;
    height: 100%;
    max-height: 100%;
    padding-right: 10px;
    background: transparent;
    box-shadow: none;
  }

  .imagen-principal-wrapper {
    margin-left: 0;
    width: 100%;
    max-width: 100%; /* Ocupar todo el ancho disponible de la columna */
    aspect-ratio: auto; /* Dejar que la imagen defina o mantener proporción */
    box-shadow: none; /* Más limpio */
    border: 1px solid #f0f0f0;
  }
  
  .info-producto {
      position: sticky;
      top: 100px; /* Para que siga al usuario al hacer scroll si la galería es muy alta */
  }
}

/* TOGGLE SWITCH STYLES */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 28px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #ffdd57; /* Warning color */
}

input:focus + .slider {
  box-shadow: 0 0 1px #ffdd57;
}

input:checked + .slider:before {
  transform: translateX(22px);
}
</style>
